<div id="course-exporter-holder">
  <div id="course-exporter">
    Export: {{level}}
    <select id="exportLevel" name="exportLevel">
      <option value='page'>Current Page</option>
      <!--option value='activity'>Activity</option-->
      <!--option value='module'>Module</option-->
      <option value='menus'>Menus</option>
      <option value='navigation'>Navigation</option>
      <option value='course_pages' selected="selected">All Page Content</option>
      <option value='course'>Entire Course</option>
    </select>
    <button id="exportBtn">Export</button>
  </div>
</div>
